
import { Component, Prop, mixins, Ref } from 'nuxt-property-decorator';
import Draggable from 'vuedraggable';
import Collapsible from '../layout/Collapsible.vue';
import InputValidationMixin from '../design-system/input/InputValidationMixin';
import Modal from '../modals/Modal.vue';
import ActionButton from '../action/ActionButton.vue';
import { AuthorDto } from '../../services';
import AuthorModal from './AuthorModal.vue';
import { v4 as uuid } from 'uuid';

export interface AuthorUnderEdition extends AuthorDto {
  index: number | null;
}

@Component({
  components: {
    AuthorModal,
    Collapsible,
    Draggable,
  },
})
export default class Authors extends mixins(InputValidationMixin) {
  @Prop({ type: String, required: true }) readonly id!: string;
  @Prop({ type: String }) value!: string;
  @Ref() readonly authorModal?: Modal;
  @Ref() readonly addbtn!: ActionButton;
  @Prop(Boolean) readonly disabled!: boolean;

  authors: AuthorDto[] = [];
  innerValue: AuthorDto[] = [];
  authorUnderEdition: AuthorUnderEdition = {
    index: null,
    id: '',
    firstName: '',
    lastName: '',
    email: '',
    order: 0,
    isPresenter: false,
    affiliations: [],
    userId: null,
    participantId: null,
  };

  get affiliations(): string[] {
    return this.authors.flatMap(a => a.affiliations);
  }

  created() {
    if (this.value) {
      this.authors = JSON.parse(this.value);
      this.innerValue = this.authors;
    }
    this.validationRules.minimum_one_presenter = true;
    this.validationRules.duplicate_author_email = true;
  }

  public createOrUpdateAuthor(author: any) {
    this.$wait.start('update');
    const index = author.index;

    // We do not want to persist this information.
    delete author.index;

    if (index !== null) {
      this.$set(this.authors, index, author);
    } else {
      this.authors.push(author);
    }

    this.innerValue = this.authors;
    this.emitInput();
    this.authorModal?.triggerVisibility();
    this.$wait.end('update');
  }

  public createAuthor(event: PointerEvent) {
    this.authorUnderEdition.index = null;
    this.authorUnderEdition.id = uuid();
    this.authorUnderEdition.firstName = '';
    this.authorUnderEdition.lastName = '';
    this.authorUnderEdition.email = '';
    this.authorUnderEdition.isPresenter = false;
    this.authorUnderEdition.affiliations = [];
    this.authorUnderEdition.order = 0;
    this.authorModal?.triggerVisibility(event.currentTarget);
  }

  public editAuthor(index: number, event: PointerEvent) {
    this.authorUnderEdition = Object.assign({ index }, this.authors[index]);
    this.$nextTick(() => this.authorModal?.triggerVisibility(event.currentTarget));
  }

  public deleteAuthor(index: number) {
    this.authors.splice(index, 1);
    this.emitInput();
  }

  public emitInput() {
    this.$emit('input', JSON.stringify(this.authors));
  }
}
